import { Component, Input } from '@angular/core';
import { CraftDetailsDto } from '@flyfreely-portal-ui/flyfreely';

@Component({
    selector: 'rpa-list-item',
    templateUrl: './rpa-list-item.component.html',
    styleUrls: ['./rpa-list-item.component.scss']
})
export class RpaListItemComponent {
    @Input() item: CraftDetailsDto;
    @Input() showCustodian = false;
}
